<div id="content" class="allcp-form" ng-controller="TeamController" ng-init="init()">
    <div ng-include="'modules/company/menus/user_menu.html'"></div>
    <div class="panel-body">
        <div ng-if="data.teams.data.length > 0">
            <div class="col-md-4 well m20" style="background:#fff" ng-repeat="item in data.teams.data | filter: data.term">
                <div class="row">
                    <div class="col-md-9">
                        <b>{{ item.name }}</b>
                        <p>{{ item.description }}</p>
                    </div>
                </div>
                <hr style="margin:10px 0 !important">
                <ul class="worker-lists clearfix" ng-if="item.workers.length > 0">
                    <li ng-repeat="worker in item.workers">
                        <a href="#" ng-click="getWorkerDetails(worker.id)" class="hint--medium hint--top" aria-label="{{ worker.full_name }}">
                            <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ worker.profile_photo }}" alt="Image" border="0" class="img-circle" width="64px" height="64px">
                        </a>
                    </li>
                </ul>
                <ul class="worker-lists clearfix" ng-if="item.workers.length == 0">
                    <li>
                        Henüz bu ekibe atanmış çalışan bulunmamaktadır.
                    </li>
                </ul>
                <hr style="margin:10px 0 !important">
                <a href="ekip-yonetimi/detay/{{ item.id }}" class="pull-left"> Düzenle </a>
                <a href="#" class="pull-right text-danger" ng-click="delete(item.id,'set')"> Sil </a>
            </div>
        </div>
        <div ng-if="data.teams.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Hiç ekip oluşturmadınız! <a href="/yeni-ekip">Buraya</a> tıklayarak yeni ekip oluşturubilirsiniz.
                </strong>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
            </div>
            <div class="modal-body">
                <strong class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
                </strong>
                <p>
                    <strong>Silmek istediğinizden emin misiniz ? </strong>
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                <button type="button" class="btn btn-danger" ng-click="delete('','delete')" data-dismiss="modal">Sil</button>
            </div>
        </div>
    </div>
</div>
</div>